
import type { PropType } from 'vue'
import type { KeywordsMessages } from '../../../models/i18n/insights.messages'

import type { KeywordData } from '../../../models/views/keywords'
import { defineComponent } from 'vue'

import FadingScroll from '../../fading-scroll.component.vue'
import TransitionSize from '../../transition-size.component.vue'
import KeywordDetails from './keyword-details.component.vue'

export default defineComponent({
  name: 'EpbKeywordsAside',
  components: {
    FadingScroll,
    TransitionSize,
    KeywordDetails,
  },
  props: {
    keywords: {
      type: Array as PropType<Array<KeywordData>>,
      required: true,
    },
    messages: {
      type: Object as PropType<KeywordsMessages['aside']>,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-keywords-aside',
    }
  },
})
